// export const PARTS_ENDPOINT = "http://rhinestahl-r00.loc/wp-json/rhinestahl/v1/tooling";
// export const FILTER_OPTIONS_ENDPOINT = "http://rhinestahl-r00.loc/wp-json/rhinestahl/v1/filter-options";
// export const REQUEST_ENDPOINT = "http://rhinestahl-r00.loc/wp-json/rhinestahl/v1/submitRequest";


// export const PARTS_ENDPOINT = "http://dev.rhinestahl.usdigitalpartners.net/wp-json/rhinestahl/v1/tooling";
// export const FILTER_OPTIONS_ENDPOINT = "http://dev.rhinestahl.usdigitalpartners.net/wp-json/rhinestahl/v1/filter-options";
// export const REQUEST_ENDPOINT = "http://dev.rhinestahl.usdigitalpartners.net/wp-json/rhinestahl/v1/submitRequest";

export const PARTS_ENDPOINT = "https://www.rhinestahl.com//wp-json/rhinestahl/v1/tooling";
export const FILTER_OPTIONS_ENDPOINT = "https://www.rhinestahl.com//wp-json/rhinestahl/v1/filter-options";
export const REQUEST_ENDPOINT = "https://www.rhinestahl.com//wp-json/rhinestahl/v1/submitRequest";

export const fetchPagedProducts = (state = { paged: 1, orderby: "", order: "", searchTerm: "" }) => {
  return fetch(`${PARTS_ENDPOINT}?paged=${state.paged}&orderby=${state.orderby}&order=${state.order}&search=${state.searchTerm}&filters=${JSON.stringify(state.selectedFilters)}`)
    .then((res) => res.json());
}

export const fetchFilterOptions = () => {
  return fetch(`${FILTER_OPTIONS_ENDPOINT}`)
    .then((res) => res.json());
}